/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Box, Button, Grid, Link, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { signOut } from "aws-amplify/auth";
import { RootState, useAppDispatch } from "@store/store";
import { InactivityHandler } from "@components/InactivityHandler";
import IconRejected from "@components/Images/IconRejected";
import CustomRightImage from "@components/CustomRightImagev2";
import { setModalErrorVisible } from "@store/slices/appSlice";
import { useLazyGetCuentasByIdQuery } from "@api/account";
import { ApiError } from "@interfaces/response";

const Rechazo = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const personalData = useSelector((state: RootState) => state.register.personal_data);

  const [getAccountData] = useLazyGetCuentasByIdQuery();

  const [name, setName] = useState("");

  const handleClick = async () => {
    await signOut();
    navigate("/login");
  };

  const fetchData = async () => {
    try {
      const response = await getAccountData({ id: personalData.id }).unwrap();
      const account_data = response.data;
      const fullName = `${account_data.name} ${account_data.last_name} ${account_data.last_name_2}`;
      setName(fullName);
    } catch (error) {
      dispatch(setModalErrorVisible({ open: true, error: error as ApiError }));
    }
  };

  useEffect(() => {
    document.body.style.backgroundColor =
      theme?.palette?.screenBackground?.backgroundColor || theme?.palette?.primary?.dark;
    fetchData();

    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={5}>
        <InactivityHandler />
        <Box>
          <Typography
            variant={isMobileOrTablet ? "h4" : "h3"}
            color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary?.light}
            fontWeight={500}
            align="center"
          >
            ¡Hola!
          </Typography>

          <Typography
            variant={isMobileOrTablet ? "h4" : "h3"}
            color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary?.light}
            fontWeight={500}
            align="center"
          >
            {name}
          </Typography>

          <Typography
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.screenBackground?.subTextColor || theme?.palette?.primary?.light}
            align="center"
            mt={3}
          >
            Lamentamos informarte que, por el momento, no pudimos autorizar tu solicitud de crédito
          </Typography>

          <Typography
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary?.light}
            align="center"
            mt={3}
            fontWeight={700}
          >
            ¡No te desanimes! <br />
            Puedes volver a intentarlo en 3 meses
          </Typography>

          <Box display="flex" justifyContent="center" mt={4}>
            <IconRejected width={isMobileOrTablet ? "110" : "170"} fill={theme.palette.screenBackground?.iconColor || theme.palette.primary.light} />
          </Box>

          <Typography
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.screenBackground?.subTextColor || theme?.palette?.primary?.light}
            align="center"
            mt={3}
          >
            Para cualquier duda o aclaración contáctanos a: <br />
            Tel:{" "}
            <Link href="tel:+525591044964" color={theme?.palette?.screenBackground?.subTextColor || theme?.palette?.primary?.light}>
              55 9104 4964
            </Link>
          </Typography>

          <Typography
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.screenBackground?.subTextColor || theme?.palette?.primary?.light}
            align="center"
            fontWeight={300}
            mt={1}
          >
            Correo:{" "}
            <Link href="mailto:contacto@lendia.mx" color={theme?.palette?.screenBackground?.subTextColor || theme?.palette?.primary?.light}>
              contacto@lendia.mx
            </Link>
          </Typography>

          <Box display="flex" justifyContent="center" mt={3}>
            <Button variant="default" onClick={handleClick} sx={{ width: "130px" }}>
              Salir
            </Button>
          </Box>
        </Box>
      </Grid>

      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default Rechazo;
